module.exports = __webpack_public_path__ + "img/australia.0bdacf51.svg";